// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.datalens-chartkit-error {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 16px;
  overflow: auto;
}
.datalens-chartkit-error__title {
  display: flex;
  align-items: center;
  color: var(--g-color-text-primary);
  font-size: 13px;
  line-height: 16px;
  margin-bottom: 12px;
}
.datalens-chartkit-error__title_mobile {
  font-family: var(--g-text-body-font-family);
  font-weight: var(--g-text-body-font-weight);
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}
.datalens-chartkit-error .datalens-chartkit-error__icon {
  color: var(--g-color-text-danger);
  margin-right: 8px;
  flex-shrink: 0;
}
.datalens-chartkit-error .datalens-chartkit-error__icon_no-data {
  color: var(--g-color-base-neutral-heavy);
}
.datalens-chartkit-error__actions {
  margin-bottom: 12px;
}
.datalens-chartkit-error__action:not(:first-child) {
  margin-left: 10px;
}
.datalens-chartkit-error__request-id {
  color: var(--g-color-text-hint);
  letter-spacing: 1px;
  font-size: 11px;
  margin-bottom: 6px;
}
.datalens-chartkit-error__report {
  color: var(--g-color-text-secondary);
  font-size: 13px;
  line-height: 16px;
}
.datalens-chartkit-error__message {
  padding-left: 28px;
  margin-bottom: 8px;
  color: var(--g-color-text-misc);
}
.datalens-chartkit-error__code-block {
  font-family: "Consolas", "Menlo", "Ubuntu Mono", monospace;
  white-space: pre-wrap;
  word-wrap: break-word;
  background-color: var(--dl-color-dashboard-background, var(--g-color-base-generic-ultralight));
  padding: 10px;
  font-size: 13px;
  border-radius: 4px;
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/Error/Error.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAIA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AAHJ;AAKI;EACI,aAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAHR;AAKQ;EC0JJ,2CAAA;EACA,2CAAA;EACA,yCAAA;EACA,6CAAA;AD5JJ;AAII;EACI,iCAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAIQ;EACI,wCAAA;AAFZ;AAMI;EACI,mBAAA;AAJR;AAQQ;EACI,iBAAA;AANZ;AAUI;EACI,+BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AARR;AAWI;EACI,oCAAA;EACA,eAAA;EACA,iBAAA;AATR;AAYI;EACI,kBAAA;EACA,kBAAA;EACA,+BAAA;AAVR;AAaI;EACI,0DA/Dc;EAgEd,qBAAA;EACA,qBAAA;EACA,8FAAA;EAIA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AAdR","sourcesContent":[".datalens-chartkit-error {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  padding: 16px;\n  overflow: auto;\n}\n.datalens-chartkit-error__title {\n  display: flex;\n  align-items: center;\n  color: var(--g-color-text-primary);\n  font-size: 13px;\n  line-height: 16px;\n  margin-bottom: 12px;\n}\n.datalens-chartkit-error__title_mobile {\n  font-family: var(--g-text-body-font-family);\n  font-weight: var(--g-text-body-font-weight);\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}\n.datalens-chartkit-error .datalens-chartkit-error__icon {\n  color: var(--g-color-text-danger);\n  margin-right: 8px;\n  flex-shrink: 0;\n}\n.datalens-chartkit-error .datalens-chartkit-error__icon_no-data {\n  color: var(--g-color-base-neutral-heavy);\n}\n.datalens-chartkit-error__actions {\n  margin-bottom: 12px;\n}\n.datalens-chartkit-error__action:not(:first-child) {\n  margin-left: 10px;\n}\n.datalens-chartkit-error__request-id {\n  color: var(--g-color-text-hint);\n  letter-spacing: 1px;\n  font-size: 11px;\n  margin-bottom: 6px;\n}\n.datalens-chartkit-error__report {\n  color: var(--g-color-text-secondary);\n  font-size: 13px;\n  line-height: 16px;\n}\n.datalens-chartkit-error__message {\n  padding-left: 28px;\n  margin-bottom: 8px;\n  color: var(--g-color-text-misc);\n}\n.datalens-chartkit-error__code-block {\n  font-family: \"Consolas\", \"Menlo\", \"Ubuntu Mono\", monospace;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  background-color: var(--dl-color-dashboard-background, var(--g-color-base-generic-ultralight));\n  padding: 10px;\n  font-size: 13px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
